module.exports = __webpack_public_path__ + "static/media/country_gd.32f51795.webp";